import React, { useState } from 'react';
import AddScoreModal from '../models/AddScoreModal';

const WeekDataTable = ({ data, selectedMainInfoId, url, handleMainInfoChange, showToast }) => {
    const [showModal, setShowModal] = useState(false);

    if (!selectedMainInfoId) return null;

    const categories = [
        { key: "scratch_game_team", label: "Scratch Game Team" },
        { key: "scratch_series_team", label: "Scratch Series Team" },
        { key: "handicap_game_team", label: "Handicap Game Team" },
        { key: "handicap_series_team", label: "Handicap Series Team" },
        { key: "handicap_series_men", label: "Handicap Series Men" },
        { key: "scratch_series_men", label: "Scratch Series Men" },
        { key: "handicap_game_men", label: "Handicap Game Men" },
        { key: "scratch_game_men", label: "Scratch Game Men" },
        { key: "handicap_series_women", label: "Handicap Series Women" },
        { key: "handicap_game_women", label: "Handicap Game Women" },
        { key: "scratch_series_women", label: "Scratch Series Women" },
        { key: "scratch_game_women", label: "Scratch Game Women" },
    ];

    const combinedRows = [];

    categories.forEach(({ key, label }) => {
        data[0]?.[key]?.forEach(entry => {
            combinedRows.push({
                category: label,
                name: entry.team,
                score: entry.score
            });
        });
    });

    const handleAddScore = async (formData) => {
        try {
            const response = await fetch(`${url}/high-scores`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ...formData, mainInformationId: selectedMainInfoId })
            });
            if (!response.ok) throw new Error("Failed to update team");
            setShowModal(false);
            showToast(`✅ ${formData.name} added to ${formData.category.replace(/_/g, " ")}!`, "success");
            handleMainInfoChange(selectedMainInfoId);
        } catch (err) {
            showToast("❌ Error updating team: " + err.message, "error");
        }
    };

    return (
        <div className="container mt-4 mb-5">
            <h2 className="text-center mb-4 fw-bold display-9">📈 Season High Scores</h2>
            <div className="text-end mb-3">
                <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Add Score</button>
            </div>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                        <tr>
                            <th>Category</th>
                            <th>Name</th>
                            <th>Score</th>
                        </tr>
                    </thead>
                    <tbody>
                        {combinedRows.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="text-center">No high scores added yet.</td>
                            </tr>
                        ) : (combinedRows.map((row, idx) => (
                            <tr key={idx}>
                                <td>{row.category}</td>
                                <td>{row.name}</td>
                                <td>{row.score}</td>
                            </tr>
                        )))}
                    </tbody>
                </table>
            </div>

            <AddScoreModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onSubmit={handleAddScore}
                categories={categories}
            />
        </div>
    );
};

export default WeekDataTable;
